import React from 'react';
import { Countdown } from './Countdown';
export function OfferBar() {
  return <a href="#precios" className="sticky top-0 z-30 block bg-pumpkin px-4 py-2.5 text-center text-sm font-semibold text-night transition-colors duration-150 ease-out hover:bg-pumpkin-soft" data-id="element-139" data-mp="130lfrfaiqeut">
      Oferta de lanzamiento <span className="hidden sm:inline" data-id="element-140" data-mp="t1mh8pjgvzlj">· 6 tomos + 3 extras desde $14.999</span> · termina en <Countdown variant="inline" data-id="element-141" data-mp="fazf0nehzrkp" />
    </a>;
}